import React from 'react';
import './styles.scss';

const Header = () => (
  <header className='header'>
    <div className='header__container'>
      <div className='header__logo'>I&apos;m the logo</div>
      <div className='header__text'>I&apos;m the text</div>
    </div>
  </header>
);

export default Header;
